module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "griddy-contain"
  }, [_vm._m(0), _vm._v(" "), _c('videoBg')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "griddy container is-flui"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-hidden-mobile"
  }, [_c('h1', [_vm._v("SARIKAYA\n          "), _c('span', {
    staticClass: "plus"
  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
    staticClass: "s"
  }, [_vm._v("S")]), _vm._v("AH"), _c('span', {
    staticClass: "i"
  }, [_vm._v("I")]), _vm._v("N")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('p', [_vm._v("Today, the impact of rapid changes in technology and economy is also manifested in the field of law. Therefore, these changes bring the necessity for dynamic, open-minded and professionally up-to-date lawyers more than ever. Sarıkaya + Şahin aims to respond to these necessities while enhancing its services to come along with the best possible solutions.")]), _vm._v(" "), _c('span', {
    staticClass: "liner"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-398fdf96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/homepage.vue
// module id = 118
// module chunks = 0